import { AsyncPipe, CurrencyPipe, DecimalPipe, NgTemplateOutlet } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { SavingsPlanFacade } from '@zero/saving-plans/domain';
import { LoadingIndicatorDirective } from '@zero/shared/ui-directives';
import { ExanteUriPipe } from '@zero/shared/ui-pipes';
import { InstrumentType } from '@zero/shared/util-models';

@Component({
  selector: 'saving-plans-confirm-assets',
  imports: [TranslocoPipe, AsyncPipe, CurrencyPipe, LoadingIndicatorDirective, ExanteUriPipe, NgTemplateOutlet, DecimalPipe],
  templateUrl: './savings-plan-confirm-assets.component.html',
  styleUrl: './savings-plan-confirm-assets.component.scss',
})
export class SavingsPlanConfirmAssetsComponent implements OnInit {
  public readonly facade = inject(SavingsPlanFacade);

  public readonly InstrumentType = InstrumentType;

  ngOnInit(): void {
    this.facade.loadExante();
  }
}
